<style scoped>
.circle {
	width: 7px;
	height: 7px;
	border-radius: 50%;
	display: inline-block;
}
</style>
// colors taken from @online-green and @offline-gray in custom-variables.less
<template>
	<div
		class="circle"
		:style="{ backgroundColor: isOnline ? '#88bf67' : '#c9c9c9' }"
	></div>
</template>

<script>
import Vue from "vue";
// Other components
import { i18n } from "../utils";

export default {
	name: "actor-online-status",
	props: ["actor"],
	computed: {
		isOnline() {
			return VueStore.getters.actorData(this.actor.id).isOnline;
		},
	},
};
</script>
